import React, { useEffect } from "react";
import Lucide from "../Lucide";
import "./Toast.css";
import AlertComponent, { AlertVariant } from "../Alert";

export interface ToastProps {
  id?: string;
  destroy: () => void;
  title: string;
  content: string;
  duration?: number;
  type: AlertVariant;
}

const Toast: React.FC<ToastProps> = (props) => {
  const {
    destroy,
    content,
    title = "Changes saved successfully.",
    duration = 2000,
    id,
    type = "primary",
  } = props;

  useEffect(() => {
    if (!duration) return;
    const timer = setTimeout(() => {
      destroy();
    }, duration);
    return () => clearTimeout(timer);
  }, [destroy, duration]);

  // return (
  //   <div className={`${type}`}>
  //     <div className={'toast-header'}>
  //       <div key={id}>{title}</div>
  //       <button onClick={destroy}>
  //         <Lucide
  //           icon='X'
  //           className={type == 'warning' ? 'text-red-900' : 'text-white'}
  //         />
  //       </button>
  //       {/* <Alert variant='primary'>Awesome simple alert</Alert> */}
  //     </div>
  //     <div className={'toast-body'}>{content}</div>
  //   </div>
  // );
  return (
    <AlertComponent variant={type} dismissible={true} key={id}>
      <div className="flex flex-start justify-between items-start">
        <div className="flex flex-col gap-2">
          <div className="text-sm font-bold">{title}</div>
          <div className="text-md">{content}</div>
        </div>
        <button onClick={destroy}>
          <Lucide icon="X" />
        </button>
      </div>
    </AlertComponent>
  );
};

export default Toast;
